import React from "react"

export default function ProductNotFound() {
  return (
    <div className="product-not-found full-page-module">
      <div></div>
    </div>
  );
}